module.exports = __webpack_public_path__ + "img/02.2ec2bdeb.jpg";